import { t } from "./i18n";

// What is wrong with what a control holds, in Lantern's language rather than
// the browser's, for a field to show under it. A message a form set itself
// (setCustomValidity) is already its own and stands.

export interface Checked {
  validity: Partial<ValidityState>;
  validationMessage: string;
  type?: string;
  tagName: string;
  minLength?: number;
  maxLength?: number;
  min?: string;
  max?: string;
  step?: string;
  title?: string;
  value?: string;
}

export function invalidText(c: Checked): string {
  const v = c.validity;
  const type = c.tagName === "SELECT" ? "select" : (c.type ?? "text");
  if (v.customError) return c.validationMessage;
  if (v.valueMissing) {
    if (type === "select" || type === "radio") return t("Choose one.");
    if (type === "checkbox") return t("Tick this to go on.");
    if (type === "file") return t("Choose a file.");
    return t("Fill this in.");
  }
  if (v.badInput) {
    if (type === "number") return t("Enter a number.");
    if (type.startsWith("date") || type === "time") return t("Enter a complete date and time.");
  }
  if (v.typeMismatch) {
    if (type === "email") return t("Enter an email address, such as name@example.com.");
    if (type === "url") return t("Enter a full web address, starting with https://.");
  }
  if (v.tooShort) return t("Use at least {n} characters; this has {have}.", { n: c.minLength ?? 0, have: c.value?.length ?? 0 });
  if (v.tooLong) return t("Use at most {n} characters; this has {have}.", { n: c.maxLength ?? 0, have: c.value?.length ?? 0 });
  if (v.rangeUnderflow) return type.startsWith("date") || type === "time" ? t("Pick a later time.") : t("Use {min} or more.", { min: c.min ?? "" });
  if (v.rangeOverflow) return type.startsWith("date") || type === "time" ? t("Pick an earlier time.") : t("Use {max} or less.", { max: c.max ?? "" });
  if (v.stepMismatch) return !c.step || c.step === "1" ? t("Use a whole number.") : t("Use a multiple of {step}.", { step: c.step });
  if (v.patternMismatch && c.title) return c.title;
  if (v.patternMismatch || v.typeMismatch || v.badInput) return t("This is not in the form it needs to be.");
  return c.validationMessage;
}
